<template>
    <b-col :cols="cols">
        <csp-table
            icon="inticon-autoclaim_company"
            :items-ajax-url="itemsAjaxUrl"
            table-headline="Zugehörige Firmen"/>
    </b-col>
</template>

<script>
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    export default {
        name: 'FirmGroupFirms',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        data() {
            const firmGroupId = this.$route.params.firmGroupId;
            return {
                firmGroupId,
            };
        },
        computed: {
            itemsAjaxUrl() {
                return `/api/desktop/firm-groups/${this.firmGroupId}/firms`;
            },
        },
    }
</script>
